const languages = ['en', 'he'];
export const languageNames = ['English', 'Slovenščina', 'Italiano', 'hebrew'];

export default languages;
